import { useState } from "react";
import {
  Group,
  Image,
  Stack,
  Text,
  Button,
  HoverCard,
  Modal,
  Loader,
} from "@mantine/core";
import { IconLogout, IconSwitchHorizontal } from "@tabler/icons-react";
import useUser from "@/hooks/use-user";
import { loginWithGoogle, logout } from "../../../firebase/authentication";
import { useRouter } from "next/navigation";
import classes from "./Sidebar.module.css";
import { ConfirmationModal } from "../alerts/ConfirmationModal";

const SidebarUserButton = () => {
  const { user, loading } = useUser();
  const [isLogoutModalOpened, setLogoutModalOpened] = useState(false);
  const router = useRouter();

  const handleLogoutClick = () => {
    setLogoutModalOpened(true);
  };

  const confirmLogout = () => {
    setLogoutModalOpened(false);
    logout();
    router.push("/login");
  };

  if (loading) {
    return <Loader color="gray" type="circle" />;
  }

  if (user) {
    return (
      <HoverCard shadow="xl" position="bottom">
        <HoverCard.Target>
          <Group
            align="center"
            gap={15}
            m="lg"
            style={{ cursor: "pointer", position: "relative" }}
          >
            <ConfirmationModal
              opened={isLogoutModalOpened}
              onClose={() => setLogoutModalOpened(false)}
              buttonFunction={confirmLogout}
              title="Logout"
              message="You are about to logout. Are you sure?"
              buttonMessage="Logout"
              buttonColor="gray"
            />
            <Image
              src={user.photoURL || "/default_avatar.png"}
              alt={user.displayName || "User"}
              width={40}
              height={40}
              radius="xl"
              style={{ cursor: "pointer" }}
            />
            <Stack gap={0}>
              <Text size="sm" fw={500}>
                {user.displayName}
              </Text>
              <Text size="sm" fw={500} style={{ color: "gray" }}>
                {user.email}
              </Text>
            </Stack>
          </Group>
        </HoverCard.Target>
        <HoverCard.Dropdown
          classNames={{
            dropdown: classes.dropdownUser,
          }}
        >
          <Button
            color="gray"
            variant="transparent"
            size="xs"
            onClick={handleLogoutClick}
            className={classes.dropdownButton}
          >
            <IconLogout
              size="1rem"
              stroke={1.5}
              style={{ marginRight: "0.5rem" }}
            />
            <span>Logout</span>
          </Button>
        </HoverCard.Dropdown>
      </HoverCard>
    );
  } else {
    return (
      <a href="#" className={classes.link} onClick={() => loginWithGoogle()}>
        <IconSwitchHorizontal className={classes.linkIcon} stroke={1.5} />
        <span>Login</span>
      </a>
    );
  }
};

export default SidebarUserButton;
